import React, { useState } from "react";
import "./RummyTableHistoryInnerRound.css";
import { Button, Modal } from "react-bootstrap";
import RummyTableHistoryInnerRoundCards from "../RummyTableHistoryInnerRoundCards/RummyTableHistoryInnerRoundCards";

function RummyTableHistoryInnerRound(props) {
  const [rummyWalletHistoryCards, setRummyWalletHistoryCards] = useState([]);

  const [showRummyWalletHistory, setShowRummyWalletHistory] = useState(false);

  return (
    <div className="Successfull_Modal_sec">
      <Modal
        className="Successfull_Modal rc-modal"
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>Player Round History</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="rummy-history-table-wrapper">
            <table className="rummy-history-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Round No</th>
                  {/* <th>Game Points</th> */}
                  <th>loss Points</th>
                  <th>Remark</th>
                  <th>View Cards</th>
                </tr>
              </thead>

              <tbody>
                {props?.rummyWalletHistory?.length > 0 ? (
                  props.rummyWalletHistory.map((item, index) => (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      <td>{item.round_no || "-"}</td>
                      {/* <td>{props?.history?.[0]?.winning_point ?? "-"}</td> */}
                      <td className="rc-loss-points">- {item.points ?? "-"}</td>
                      <td>{item.win_loss ?? "-"}</td>
                      <td>
                        {" "}
                        <Button
                          className="rs-view-btn"
                          onClick={() => {
                            setShowRummyWalletHistory(true);
                            setRummyWalletHistoryCards(
                              item?.RummyGameRoundHistoryCards,
                            );
                          }}>
                          View
                        </Button>{" "}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="no-history">
                      No round history found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <RummyTableHistoryInnerRoundCards
        onHide={() => setShowRummyWalletHistory(false)}
        show={showRummyWalletHistory}
        rummyWalletHistoryCards={rummyWalletHistoryCards}
      />
    </div>
  );
}

export default RummyTableHistoryInnerRound;
